import React from 'react';
import { SageTokens, IconCard, Icon, SageClassnames, Frame, Button } from '@kajabi/sage-react';
import { ERROR_TYPES } from 'common/components/CopyMagic/constants';
import { useUiResourceContext } from 'common/components/CopyMagic/contexts';
import { useMessagesContext } from 'common/components/CopyMagic/contexts/MessagesContext';

const ErrorMessageFullscreen = () => {
  const { error, resetError, resetPromptValues } = useUiResourceContext();
  const { resetMessages } = useMessagesContext();

  if (!error) return null;

  const iconColor =
    error?.type === ERROR_TYPES.WARN ? IconCard.COLORS.WARNING : IconCard.COLORS.DANGER;

  const handleRestart = () => {
    resetMessages();
    resetError();
    resetPromptValues();
  };

  return (
    <div
      data-testid="copy-magic-error-message-fullscreen"
      className={[SageClassnames.TYPE.BODY_SMALL, 'copy-magic-error-fullscreen'].join(' ')}
    >
      <Frame
        direction={Frame.DIRECTIONS.VERTICAL}
        padding={Frame.PADDINGS.MD}
        align={Frame.ALIGNMENTS.CENTER_CENTER}
        width={Frame.WIDTHS.FLEX}
        className={SageClassnames.TYPE_ALIGN_CENTER}
      >
        <IconCard
          color={iconColor}
          icon={SageTokens.ICONS.WARNING_FILLED}
          size={Icon.SIZES.XL}
          style={{ maxWidth: 70, marginRight: 'auto', marginLeft: 'auto', padding: 20 }}
        />
        {error.message}
        <Button onClick={handleRestart} color={Button.COLORS.PRIMARY} icon={Icon.ICONS.SYNC}>
          Restart chat
        </Button>
      </Frame>
    </div>
  );
};

export default ErrorMessageFullscreen;
